import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <section
        className="hero-section min-h-[600px] flex items-center"
        style={{ backgroundImage: 'url(https://images.pexels.com/photos/5953716/pexels-photo-5953716.jpeg?auto=compress&cs=tinysrgb&w=1920)' }}
      >
        <div className="hero-overlay w-full min-h-[600px] flex items-center">
          <div className="container mx-auto px-4 text-white">
            <div className="max-w-3xl">
              <h1 className="text-5xl md:text-6xl font-bold mb-6">
                ATHENA PROCESS DESIGN & MANUFACTURING
              </h1>
              <p className="text-xl md:text-2xl mb-4 text-green font-semibold">
                ISO 9001:2015 & ISO 14001:2015 Certified
              </p>
              <p className="text-lg md:text-xl mb-8 text-gray-200">
                Excellence in designing, manufacturing, and executing projects for Dairy, Food Beverages, Pharmaceuticals, and Herbal industries since 2017
              </p>
              <div className="flex flex-wrap gap-4">
                <Link to="/services" className="btn-primary px-8 py-3 rounded-lg text-lg font-semibold">
                  Explore Services
                </Link>
                <Link to="/contact" className="bg-white text-black px-8 py-3 rounded-lg text-lg font-semibold hover:bg-gray-100 transition">
                  Get Quote
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Overview */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4 section-title inline-block">
              Welcome to Athena
            </h2>
            <p className="text-xl text-gray-600 mt-8 max-w-4xl mx-auto">
              ATHENA PROCESS DESIGN & MANUFACTURING is a budding engineering company which deals with designing, Manufacturing, Fabrication and execution of projects in the arena of Dairy, Food Beverages, Pharmaceuticals and Herbal industries.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mt-12">
            <div className="text-center p-6 card-hover bg-gray-50 rounded-lg">
              <div className="text-5xl font-bold text-accent mb-4">2017</div>
              <h3 className="text-xl font-semibold mb-2">Established</h3>
              <p className="text-gray-600">Young and dynamic company with fresh perspectives</p>
            </div>
            <div className="text-center p-6 card-hover bg-gray-50 rounded-lg">
              <div className="text-5xl font-bold text-green mb-4">24+</div>
              <h3 className="text-xl font-semibold mb-2">Years of Leadership Experience</h3>
              <p className="text-gray-600">Led by Mr. M.K. Singh (B.E. Mechanical)</p>
            </div>
            <div className="text-center p-6 card-hover bg-gray-50 rounded-lg">
              <div className="text-5xl font-bold text-accent mb-4">ISO</div>
              <h3 className="text-xl font-semibold mb-2">Certified Quality</h3>
              <p className="text-gray-600">ISO 9001:2015 & ISO 14001:2015 Certified</p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Expertise */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4 section-title inline-block">
              Our Expertise
            </h2>
            <p className="text-xl text-gray-600 mt-8">
              Comprehensive solutions for process industries
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Link to="/services/evaporators" className="card-hover bg-white p-6 rounded-lg border-2 border-gray-100">
              <h3 className="text-xl font-bold mb-3 text-accent">Evaporators</h3>
              <p className="text-gray-600 mb-4">Falling Film, Forced Recirculation, Scrapped Surface, Wiped Film, and more</p>
              <span className="text-green font-semibold">Learn More →</span>
            </Link>

            <Link to="/services/dryers" className="card-hover bg-white p-6 rounded-lg border-2 border-gray-100">
              <h3 className="text-xl font-bold mb-3 text-accent">Dryers</h3>
              <p className="text-gray-600 mb-4">Spray Dryer, Fluid Bed, Vacuum Band, Vacuum Tray, Ring, Rotary, and more</p>
              <span className="text-green font-semibold">Learn More →</span>
            </Link>

            <Link to="/services/dairy-equipment" className="card-hover bg-white p-6 rounded-lg border-2 border-gray-100">
              <h3 className="text-xl font-bold mb-3 text-accent">Dairy Equipment</h3>
              <p className="text-gray-600 mb-4">Complete range from milk tankers to processing equipment</p>
              <span className="text-green font-semibold">Learn More →</span>
            </Link>

            <Link to="/services/mixers" className="card-hover bg-white p-6 rounded-lg border-2 border-gray-100">
              <h3 className="text-xl font-bold mb-3 text-accent">Mixers</h3>
              <p className="text-gray-600 mb-4">Twin Shaft, Paddle, Turbo Blender, Sigma, Ribbon Blender</p>
              <span className="text-green font-semibold">Learn More →</span>
            </Link>

            <Link to="/services/accessories" className="card-hover bg-white p-6 rounded-lg border-2 border-gray-100">
              <h3 className="text-xl font-bold mb-3 text-accent">Accessories</h3>
              <p className="text-gray-600 mb-4">Screw Conveyor, Compactor, Sieving Systems, Milling Machines</p>
              <span className="text-green font-semibold">Learn More →</span>
            </Link>

            <Link to="/services/herbal-extraction" className="card-hover bg-white p-6 rounded-lg border-2 border-gray-100">
              <h3 className="text-xl font-bold mb-3 text-accent">Herbal Extraction</h3>
              <p className="text-gray-600 mb-4">Extractors, Columns, Filters for pharmaceutical applications</p>
              <span className="text-green font-semibold">Learn More →</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Turnkey Projects */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4 section-title inline-block">
              Turnkey Projects
            </h2>
            <p className="text-xl text-gray-600 mt-8">
              End-to-end solutions from design to commissioning
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-6">
            <Link to="/projects/liquid-milk" className="card-hover p-6 bg-gray-50 rounded-lg text-center">
              <h3 className="font-bold text-lg mb-2">Liquid Milk Processing</h3>
              <p className="text-sm text-gray-600">5,000 to 10,00,000 liters/day</p>
            </Link>
            <Link to="/projects/ghee" className="card-hover p-6 bg-gray-50 rounded-lg text-center">
              <h3 className="font-bold text-lg mb-2">Ghee Processing</h3>
              <p className="text-sm text-gray-600">Complete Agmark standard plants</p>
            </Link>
            <Link to="/projects/smp-wmp" className="card-hover p-6 bg-gray-50 rounded-lg text-center">
              <h3 className="font-bold text-lg mb-2">SMP/WMP/Dairy Whitener</h3>
              <p className="text-sm text-gray-600">Powder production plants</p>
            </Link>
            <Link to="/projects/ice-cream" className="card-hover p-6 bg-gray-50 rounded-lg text-center">
              <h3 className="font-bold text-lg mb-2">Ice Cream Plant</h3>
              <p className="text-sm text-gray-600">Complete processing solutions</p>
            </Link>
          </div>

          <div className="text-center mt-8">
            <Link to="/projects" className="btn-primary px-8 py-3 rounded-lg font-semibold inline-block">
              View All Projects
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4 section-title inline-block">
              Silent Features of Our Equipment
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
            <div className="bg-white p-6 rounded-lg text-center card-hover">
              <div className="text-4xl mb-4 text-accent">💪</div>
              <h3 className="font-bold mb-2">High Tensile Strength</h3>
            </div>
            <div className="bg-white p-6 rounded-lg text-center card-hover">
              <div className="text-4xl mb-4 text-green">✓</div>
              <h3 className="font-bold mb-2">Dimensional Accuracy</h3>
            </div>
            <div className="bg-white p-6 rounded-lg text-center card-hover">
              <div className="text-4xl mb-4 text-accent">⚡</div>
              <h3 className="font-bold mb-2">High Efficiency</h3>
            </div>
            <div className="bg-white p-6 rounded-lg text-center card-hover">
              <div className="text-4xl mb-4 text-green">🛡️</div>
              <h3 className="font-bold mb-2">Resistance to Corrosion</h3>
            </div>
            <div className="bg-white p-6 rounded-lg text-center card-hover">
              <div className="text-4xl mb-4 text-accent">⚙️</div>
              <h3 className="font-bold mb-2">Easy Operation</h3>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-black text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-4">
            Ready to Start Your Project?
          </h2>
          <p className="text-xl mb-8 text-gray-300">
            Get in touch with our expert team for customized solutions
          </p>
          <Link to="/contact" className="btn-primary px-10 py-4 rounded-lg text-lg font-semibold inline-block">
            Contact Us Today
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;